export enum CIRCULAR_BUTTON_SIZES {
  EXTRASMALL = 'extrasmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  LARGE_COZY = 'large-cozy',
  EXTRALARGE = 'extralarge',
}

export enum CIRCULAR_BUTTON_TYPES {
  FILL = 'fill',
  OUTLINED = 'outlined',
  ONLY_ICON = 'only-icon',
}